import React from 'react';
import RedirectLegal from './RedirectLegal';

export default function Cookies() {
  return <RedirectLegal care="cookies" />;
}
